import React, {Component} from "react"
import Dropzone from "react-dropzone"

import {H4} from "@irati/ui/src/Headings"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"

import {DropzoneWrapper, Img} from "./styled"
import addAFile from "../../images/add-a-file.png"

interface Props extends InjectIntl {
  onDrop: (acceptedFiles: File[]) => void
}

class DragAndDrop extends Component<Props> {
  render() {
    const {onDrop, formatMessage} = this.props

    return (
      <DropzoneWrapper>
        <Dropzone
          className="styledDropzone"
          accept=".csv"
          multiple={false}
          onDrop={onDrop}>
          <Img
            src={addAFile}
            alt={formatMessage({id: "platform.dragAndDrop.img.alt"})} />
          <H4 small>
            <FormattedMessage
              id="platform.dragAndDrop.text"
              values={{
                browse: <b style={{textDecoration: "underline", cursor: "pointer"}}>
                  <FormattedMessage id="platform.dragAndDrop.browse" />
                </b>
              }} />
          </H4>
        </Dropzone>
      </DropzoneWrapper>
    )
  }
}

export default injectIntl(DragAndDrop)
